import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from 'src/components/app-context';
import { Panel, PanelTitle } from '@prisjakt/ui/panel';

import { FeaturedArticle } from '../../../../components/featured-article';

import * as S from './styles';

const CampaignArticles = ({ featuredArticle, articles, campaignName }) => {
  const { t } = useContext(AppContext);

  if (articles.length === 0) {
    return null;
  }

  return (
    <S.Articles>
      <Panel>
        <PanelTitle>
          {t('campaigns', 'article.related-articles', {
            campaignName,
          })}
        </PanelTitle>
        <FeaturedArticle
          // If no featured article was found show first article
          article={featuredArticle || articles[0]}
          related={articles}
        />
      </Panel>
    </S.Articles>
  );
};

const { string, number, shape, arrayOf } = PropTypes;

const articleShape = shape({
  id: number,
  publishedAt: string,
  title: string,
  preamble: string,
  imageUrl: string,
  imageCaption: string,
  pathName: string,
});

CampaignArticles.propTypes = {
  featuredArticle: articleShape,
  articles: arrayOf(articleShape),
  campaignName: string,
};

CampaignArticles.defaultProps = {
  featuredArticle: null,
  articles: [],
  campaignName: '',
};

export default CampaignArticles;
